import { getPublicIpFromStorage } from 'Utils';

const OSType = 10;
const AppVersion = '0.1.0';
const Port = window.location.port;
const DeviceId = getPublicIpFromStorage()?.toString() || '';

export { OSType, AppVersion, Port, DeviceId };
